const style = document.createElement("style");
const text = document.createTextNode(`
table {table-layout:fixed;width: 100%;}
img {width: 100%;}
progress {width: 100%;}
input[type="text"] {width: 100%;}
`);
style.appendChild(text);
document.head.appendChild(style);
